import React, { useState } from "react";
import { Button } from "antd";
import Sidebar from "./Sidebar";
import "./styles/Profile.css";

const defaultAvatar = `${process.env.PUBLIC_URL}/logo192.png`;

const Profile = () => {
  // ✅ PRESERVED: All AFC state management (no changes)
  const [user, setUser] = useState({
    name: "John Doe",
    email: "johndoe@example.com",
    profilePic: defaultAvatar,
    isEditing: false,
  });

  // ✅ PRESERVED: All AFC handlers (no changes)
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setUser((prevUser) => ({ ...prevUser, profilePic: imageUrl }));
    }
  };

  const toggleEdit = () => {
    setUser((prevUser) => ({ ...prevUser, isEditing: !prevUser.isEditing }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser((prevUser) => ({ ...prevUser, [name]: value }));
  };

  const handleSave = () => {
    // Later: Save this to Firebase when backend is ready
    setUser((prevUser) => ({ ...prevUser, isEditing: false }));
  };

  // ✅ VISUAL UPDATE: MEO structure with scoped classes
  return (
    <div className="afc-profile dashboard-layout">
      <Sidebar />
      <div className="dashboard-main">
        <div className="dashboard-header">
          <h2 className="dashboard-logo">Profile</h2>
        </div>
        <div className="dashboard-content profile-page">
          <h3 className="profile-title">User Profile</h3>
          <div className="profile-info">
            {!user.isEditing ? (
              <>
                <div className="profile-picture">
                  <img src={user.profilePic} alt="Profile" className="profile-img" />
                </div>
                <p><strong>Username:</strong> {user.name}</p>
                <p><strong>Email:</strong> {user.email}</p>
                <Button className="update-profile-btn" onClick={toggleEdit}>
                  Edit Profile
                </Button>
              </>
            ) : (
              <div className="profile-edit-form">
                <div className="profile-picture">
                  <img src={user.profilePic} alt="Profile" className="profile-img" />
                  <input 
                    type="file" 
                    id="fileInput" 
                    onChange={handleFileChange} 
                    style={{ display: 'none' }} 
                  />
                  <label htmlFor="fileInput" className="upload-btn">Change Photo</label>
                </div>
                <div className="form-field">
                  <label>Username</label>
                  <input type="text" name="name" value={user.name} onChange={handleChange} />
                </div>
                <div className="form-field">
                  <label>Email</label>
                  <input type="email" name="email" value={user.email} onChange={handleChange} />
                </div>
                <div className="form-actions">
                  <Button type="primary" onClick={handleSave}>Save Changes</Button>
                  <Button onClick={toggleEdit} style={{ marginLeft: '10px' }}>Cancel</Button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;